import { LineChart, Line, ResponsiveContainer, YAxis } from "recharts";

/**
 * Sparkline — tiny inline chart for trend visualisation.
 *
 * Props:
 *   data: [{i, v}]
 *   color: stroke colour (default amber)
 *   height: px
 */
export default function Sparkline({ data, color = "var(--cv-amber)", height = 36, testid }) {
  if (!data || data.length === 0) return null;
  return (
    <div data-testid={testid || "sparkline"} style={{ width: "100%", height }}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data} margin={{ top: 4, right: 2, bottom: 2, left: 2 }}>
          <YAxis hide domain={["dataMin", "dataMax"]} />
          <Line
            type="monotone"
            dataKey="v"
            stroke={color}
            strokeWidth={1.8}
            dot={false}
            isAnimationActive={false}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
